import baseApi from "./baseApi"

export default  {
    /**
     * Fetch User from Server who matches token.
     * @return {Object} -- User
     */
    async getUser() {
        let request = await baseApi.createHttpRequest();
        let result = await request.get("/users/me");
        
        return result.data;
    },
     /**
     * Fetch User menu from Server who matches token.
     * @return {Object} -- User
     */
    async getUserMenu() {
        let request = await baseApi.createHttpRequest();
        let result = await request.get("/users/me/menu");

        return result.data;
    },
    /**
    * Fetch Site pages
    * @return {Object} -- Site Pages
    */
    async getSitePages() {
        let request = await baseApi.createHttpRequest();
        let result = await request.get("/users/me/sitepages");

        return result.data;
    }
}